'use strict';

import * as ko from "knockout";

import {BaseControl} from "Core/Controls/BaseControl/BaseControl";
import {IControlParam} from "Core/Screens/IScreen";

import 'Core/Controls/ButtonPrint/Templates/Edit.html';

import ViewTemplate from "Core/Controls/ButtonPrint/Templates/View.html";
import HelpViewTemplate from "Core/Controls/ButtonPrint/Templates/HelpView.html";
import ToolBarTemplate from "Core/Controls/ButtonPrint/Templates/ToolBar.html";
import DesignTemplate from "Core/Controls/ButtonPrint/Templates/Design.html";

ko.templates["Core/Controls/ButtonPrint/Templates/View"] = ViewTemplate;
ko.templates["Core/Controls/ButtonPrint/Templates/HelpView"] = HelpViewTemplate;
ko.templates["Core/Controls/ButtonPrint/Templates/ToolBar"] = ToolBarTemplate;
ko.templates["Core/Controls/ButtonPrint/Templates/Design"] = DesignTemplate;

export class ButtonPrint extends BaseControl {

	constructor(params: IControlParam) {
		super(params);
		this.Init();
	}

	ApplyProperties(){}

	private Init(): void {
	}

	AfterRender(el: Array<HTMLElement>) {
		super.AfterRender(el);
	}
}